function fixHash(id) {
  const wrongHashByVersionSwapper = '-version-swapperversion-swapper'
  return id.replace(wrongHashByVersionSwapper, '')
}

function buildVersion(dataItem) {
  const { verKey } = dataItem

  if (verKey && verKey.length) {
    const [ver] = verKey
    return ver.replace('/', '')
  }

  return ''
}

function buildResultList(dataItem) {
  const { headings, slug, title, _snippetResult } = dataItem
  const { excerpt } = _snippetResult
  const [heading] = headings

  if (heading) {
    const { id } = heading

    return [
      {
        slug,
        hash: fixHash(id),
        title,
        description: excerpt.value,
      },
    ]
  }

  return []
}

function buildData(dataItem, version, result) {
  const { category, _highlightResult } = dataItem
  const {
    title: { value: title },
  } = _highlightResult

  return {
    category,
    title,
    versions: [
      {
        version,
        result,
      },
    ],
  }
}

export { buildVersion, buildResultList, buildData }
